import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  TabActionDialog
} from "../types";
import { stringifyQs } from "../utils/urls";

export const soldoutCustomPageSection = "/soldouts/";
export const soldoutCustomPageListPath = soldoutCustomPageSection;
export type SoldoutCustomPageListUrlDialog = "remove" | TabActionDialog;
export enum SoldoutCustomPageListUrlFiltersEnum {
  isPublished = "isPublished",
  trackInventory = "trackInventory",
  query = "query"
}
export type SoldoutCustomPageListUrlFilters = Filters<
  SoldoutCustomPageListUrlFiltersEnum
>;
export type SoldoutCustomPageListUrlQueryParams = ActiveTab &
  SoldoutCustomPageListUrlFilters &
  BulkAction &
  Dialog<SoldoutCustomPageListUrlDialog> &
  Pagination;
export const soldoutCustomPageListUrl = (
  params?: SoldoutCustomPageListUrlQueryParams
) => soldoutCustomPageListPath + "?" + stringifyQs(params);
